module.exports = __webpack_public_path__ + "fonts/smartcommerce-iconfont.8a37fb1c.ttf";